module.exports = __webpack_public_path__ + "img/kalynn-bayron.9894d325.png";